import { createApiInstance } from "./api";

const tenantApiInstance = createApiInstance("/tenants");

export const tenantApi = {
  // List all tenants
  listTenants: async () => {
    const response = await tenantApiInstance.get("/");
    return response.data;
  },

  // Get tenant by ID
  getTenant: async (tenantId) => {
    const response = await tenantApiInstance.get(`/${tenantId}`);
    return response.data;
  },

  // Get tenant name by ID (accessible by user and admin)
  getTenantName: async (tenantId) => {
    const response = await tenantApiInstance.get(`/${tenantId}/name`);
    return response.data;
  },

  // Get current user's tenant name (resolves from org_id on backend)
  getMyTenantName: async () => {
    const response = await tenantApiInstance.get("/me/name");
    return response.data;
  },

  // Create a new tenant
  createTenant: async (data) => {
    const response = await tenantApiInstance.post("/", data);
    return response.data;
  },

  // Update tenant
  updateTenant: async (tenantId, data) => {
    const response = await tenantApiInstance.put(`/${tenantId}`, data);
    return response.data;
  },

  // Deactivate tenant (soft delete)
  deactivateTenant: async (tenantId) => {
    // Backend uses PATCH /tenants/{tenant_id}/deactivate for soft delete
    const response = await tenantApiInstance.patch(`/${tenantId}/deactivate`);
    return response.data;
  },

  // Reset message usage and start new billing period (super_admin only)
  resetMessageUsage: async (tenantId) => {
    const response = await tenantApiInstance.post(
      `/${tenantId}/reset-message-usage`,
    );
    return response.data;
  },

  // Enter a tenant as its admin (super_admin only) — RPAA-213
  enterTenant: async (tenantId) => {
    const response = await tenantApiInstance.post(`/${tenantId}/enter`);
    return response.data;
  },

  // Exit the currently entered tenant (super_admin only) — RPAA-213
  exitTenant: async (tenantId) => {
    const response = await tenantApiInstance.post(`/${tenantId}/exit`);
    return response.data;
  },
};
